export default __webpack_public_path__ + "static/media/maks.6f23329d.svg";